'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplicationLayout = function ApplicationLayout(_ref) {
  var sideNav = _ref.sideNav,
      sideNavState = _ref.sideNavState,
      slidingPanelState = _ref.slidingPanelState,
      children = _ref.children;

  var sideNavStyles = sideNavState || _ramda2.default.isNil(sideNavState) ? 'application-layout-side' : 'application-layout-side-collapsed';
  var filterStyles = slidingPanelState ? 'application-layout-filter' : 'application-layout-filter-collapsed';
  return _react2.default.createElement(
    'div',
    { className: 'application-layout' },
    _react2.default.createElement(
      'div',
      { className: 'application-layout-container' },
      _react2.default.createElement(
        'div',
        { className: sideNavStyles },
        sideNav
      ),
      _react2.default.createElement(
        'div',
        { className: 'application-layout-content' },
        children
      ),
      _react2.default.createElement('div', { className: filterStyles })
    )
  );
};

exports.default = ApplicationLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/layouts/ApplicationLayout/index.js
// module id = 354
// module chunks = 0